import { collection, getDocs, onSnapshot, orderBy, query } from '@firebase/firestore';
import { BaseService } from './BaseService';

export class SupplierService extends BaseService {
    constructor() {
        let collectionName = 'supplier';
        super(collectionName);
    }

    async addModal(obj, file, metadata) {
        await this.uploadImage(file, obj.Url, metadata);
        return this.addDocument(obj);
    }

    async getLayerList() {
        if (!this.status)
            return [];

        const listCol = collection(this.db, this.collectionName);
        const listSnapshot = await getDocs(listCol);

        let result = [];

        for (const doc of listSnapshot.docs) {
            let item = doc.data();

            //we get url on user first request.
            // if (item.ImageUrl)
            //     item.Url = await this.getUrl(item.ImageUrl);
            item.recordId = doc.id;

            result.push(item);
        }

        return result;
    }

    async getSupplierList(callback) {
        let colRef = collection(this.db, this.collectionName);
        colRef = query(colRef);

        const unsub = onSnapshot(colRef, (listSnapshot) => {
            this.callbackSnapshot(listSnapshot, callback);
        });

        this.unsub = unsub;
    }

    callbackSnapshot(listSnapshot, callback) {
        let ret = [];

        for (const doc of listSnapshot.docs) {
            let item = { ...doc.data(), recordId: doc.id };

            ret.push(item);
        }

        callback(ret);
    }

    async deleteLayer(recordId, path) {
        this.deleteDocument(recordId);
        if (path)
            this.deleteImage(path);
    }

    async addMultiRecord(itemList) {
        // Get a new write batch
        const batch = this.db.batch();
        const colRef = collection(this.db, this.collectionName);

        itemList.forEach(item => {
            batch.addDocument(colRef,item)
        });
        
        // Commit the batch
        await batch.commit();
    }
}
